var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"12","lg":"10","xl":"6"}},[_c('NtdInstituteTable')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }